/**
 * TDS Module Exports
 */

export * from './tds.interface';
